import { useState } from "react";
import validateEmail from "../../../utility/validator/email-validation";
import validatePhoneNumber from "../../../utility/validator/phone-no-validation";
import dataProvider from "../../../services/dataProvider";

const ContactUsForm = () => {

    var baseState ={
        name:"",
        email:"",
        phone_number:"",
        textarea:"",
        find_us:"",
        query_type:""
    }

    const [contactForm,setContactForm] = useState(baseState);

    const [emailError, setEmailError] = useState(false);
    const [phoneError, setPhoneError] = useState(false);

    const [isLoading, setIsLoading] = useState(false);
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [showErrorMessage, setShowErrorMessage] = useState("");

    var handleSubmit = (e) =>{
        e.preventDefault();
        //console.log(contactForm);
        setIsLoading(true);
        setShowErrorMessage("");
        setShowSuccessMessage(false);

        if(!validateEmail(contactForm.email)) {
            setShowErrorMessage("Please enter a valid Email");
            setIsLoading(false);
            return false;
        }

        if(!validatePhoneNumber(contactForm.phone_number)) {
            setShowErrorMessage("Please enter a valid phone number");
            setIsLoading(false);
            return false;
        }


        fetch(dataProvider.baseUrl+"contactUsQuery",{method:"POST",body:JSON.stringify(contactForm)})
        .then(res=>res.json())
        .then(result =>{
            //console.log(result);
            if(result.status === 'success')
            {
                setContactForm(baseState);
                setShowSuccessMessage(true);
                setShowErrorMessage("");
            } else {
                setShowErrorMessage("Something went wrong");
                setShowSuccessMessage(false);
            }
            setIsLoading(false);
        }).catch((error)=>{
            console.error(error);
            setShowErrorMessage(error.message);
            setShowSuccessMessage(false);
            setIsLoading(false);
        })
    }

    return (
        <div className="bg-light w-100">
            <h3 className="card-title h2 mb-5 text-secondary">
                Get in Touch
            </h3>

            {
                showSuccessMessage && (
                    <div className="alert alert-success" role="alert">
                        Message Sent Successfully
                    </div>
                )
            }

            {
                showErrorMessage && (
                    <div className="alert alert-danger" role="alert">
                        {showErrorMessage}
                    </div>
                )
            }

            <form className="" onSubmit={handleSubmit}>
                <div className="mb-3">
                    <input
                        style={{ height: "3rem" }}
                        className="border form-control ui-3 text-3"
                        type="text"
                        placeholder="Your Name *"
                        onChange={(e)=>{setContactForm({...contactForm,name:e.target.value})}}
                        value={contactForm.name}
                        required
                    />
                </div>
                <div className="mb-3">
                    <div className="row w-100 g-0">
                        <div className="col-md me-md-2 p-0">
                            <input
                                style={{ height: "3rem" }}
                                className={"border form-control ui-3 text-3 " + (emailError?"is-invalid":"")}
                                type="email"
                                placeholder="Email"
                                onChange={(e)=>{
                                    setContactForm({...contactForm,email:e.target.value});
                                    if(!validateEmail(e.target.value)){
                                        setEmailError(true);
                                    } else {
                                        setEmailError(false);
                                    }
                                }}
                                value={contactForm.email}
                                required
                            />
                            {emailError && (
                                <div className="text-danger">
                                    Invalid Email Address
                                </div>
                            )}
                        </div>
                        <div className="col-md ms-md-2 mt-3 mt-md-0 p-0">
                            <input
                                style={{ height: "3rem" }}
                                className={"border form-control ui-3 text-3 " + (phoneError?"is-invalid":"")}
                                type="text"
                                placeholder="Phone Number"
                                onChange={(e)=>{
                                    setContactForm({...contactForm,phone_number:e.target.value})
                                    if(!validatePhoneNumber(e.target.value)){
                                        setPhoneError(true);
                                    } else {
                                        setPhoneError(false);
                                    }
                                }}
                                value={contactForm.phone_number}
                                required
                            />
                            {phoneError && (
                                <div className="text-danger">
                                    Invalid Phone Number
                                </div>
                            )}
                        </div>
                    </div>
                    
                </div>
                <div className="mb-3">
                    <textarea
                        className="border form-control ui-3 text-3"
                        type="text"
                        placeholder="Message"
                        style={{minHeight:"8rem"}}
                        onChange={(e)=>{setContactForm({...contactForm,textarea:e.target.value})}}
                        value={contactForm.textarea}
                        required
                    />
                </div>
                <div className="mb-3">
                    <div className="row w-100 g-0">
                        <div className="col-md me-md-2">
                            <select 
                            style={{height : "3rem"}} 
                            className="form-select ui-3 text-3" 
                            aria-label="How Did you Find Us" 
                            onChange={(e)=>{setContactForm({...contactForm,find_us:e.target.value})}}
                            value={contactForm.find_us}
                            required>
                                <option value="" disabled>How Did you find us?</option>
                                <option value="Google">Google</option>
                                <option value="Referral">Referral</option>
                                <option value="Returning Customer">Returning Customer</option>
                                <option value="Received Email">Received Email</option>
                            </select>
                        </div>
                        <div className="col-md ms-md-2 mt-3 mt-md-0">
                            <select
                            style={{height : "3rem"}} 
                            className="form-select ui-3 text-3" 
                            aria-label="Default select example"
                            onChange={(e)=>{setContactForm({...contactForm,query_type:e.target.value})}}
                            value={contactForm.query_type}
                            required>
                                <option value="" disabled>What best describes you?</option>
                                <option value="Licensed agent">Licensed agent</option>
                                <option value="License in charge">Licensee in charge</option>
                                <option value="Business owner">Business owner</option>
                                <option value="Other">Other</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div className="d-flex d-lg-block justify-content-center">
                    {
                        isLoading ? (
                            <button
                                style={{ height: "3rem" }}
                                className="d-flex align-items-center justify-content-center btn btn-primary px-4 rounded-pill text-light"
                                disabled={true}
                            >
                                Sending...
                                <div className="spinner-border ms-4" role="status">
                                    <span className="visually-hidden">Loading...</span>
                                </div>
                            </button>
                        ) : (
                            <button
                                style={{ height: "3rem" }}
                                className="btn btn-primary px-5 rounded-pill text-light"
                            >
                                Send
                            </button>
                        ) 
                    }
                    
                </div>
            </form>
        </div>
    );
};

export default ContactUsForm;
